module.exports = __webpack_public_path__ + "static/img/gyhdzj.231e20b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/gyhdzj.jpg
// module id = Y0JC
// module chunks = 5